import { environment } from '../config/env';

const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
};

export async function apiRequest(path, { method = 'GET', headers = {}, body, token } = {}) {
  const url = `${environment.apiBaseUrl}${path}`;
  const finalHeaders = {
    ...DEFAULT_HEADERS,
    ...headers,
  };

  if (token) {
    finalHeaders.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    method,
    headers: finalHeaders,
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message = data?.message || 'Unexpected error';
    throw new Error(message);
  }

  return data;
}


